import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerGlobal = styled.div`
  box-sizing: border-box;
  position: relative;
  padding-top: 70px;
  width: 100%;
  min-height: 100vh;
  align-self: center;
  background-image: url("/imageBackHealth.png");
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ContainerContent = styled.div`
  padding: 20px 5%;
`;

export const ContainerTable = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  padding: 20px;
  width: 100%;
  height: 80vh;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
  /* overflow-x: auto; */

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${Variables.colorOrange};
  }
`;

export const ContainerHeader = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  border-bottom: 1px solid #000;
  background: ${Variables.colorWhite};
`;

export const ContainerRow = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  border-bottom: 1px solid #000;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

export const ContainFieldHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  width: 16.5%;
  height: 40px;
  overflow-wrap: break-word;

  @media (max-width: ${Variables.maxTablet}) {
    font-size: 10px;
  }

  @media (max-width: ${Variables.maxMobile}) {
    padding: 5px;
    height: 80px;
    word-break: break-all;
  }
`;

export const ContainField = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 16.5%;
  height: 40px;

  @media (max-width: ${Variables.maxTablet}) {
    font-size: 12px;
  }

  @media (max-width: ${Variables.maxMobile}) {
    padding: 5px;
    height: 80px;
    word-break: break-all;
  }
`;

export const ContainerData = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${Variables.colorOrange};
  }
`;

export const AnimationLoading = styled.div`
  position: absolute;
  left: 45%;
  top: 50%;
  display: inline-block;
  align-self: center;
  width: 80px;
  height: 80px;

  & :after {
    content: " ";
    display: block;
    margin: 8px;
    width: 64px;
    height: 64px;
    border: 6px solid ${Variables.colorPrimary};
    border-radius: 50%;
    border-color: ${Variables.colorPrimary} transparent ${Variables.colorPrimary} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const HeaderOptions = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  width: 100%;
  height: 70px;
  background-color: ${Variables.colorGray};

  @media (max-width: ${Variables.maxMobile}) {
    justify-content: space-between;
    height: 80px;
  }
`;

export const ContainerIcon = styled.div`
  left: 5px;
  align-self: center;
  cursor: pointer;
`;

export const ContainerOptions = styled.div`
  width: 90%;
`;

export const ContainerOptionHeader = styled.div`
  color: ${Variables.colorWhite};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

export const ContainerOptionAndExport = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
`;

export const TextAffiliateStatus = styled.p`
  color: ${Variables.colorGreenSuccess};
  font-weight: 600;
`;
export const TextUnaffiliatedStatus = styled.p`
  color: ${Variables.colorRed};
  font-weight: 600;
`;
export const TextPendingStatus = styled.p`
  color: ${Variables.colorOrange};
  font-weight: 600;
`;

export const InfoText = styled.p`
  margin-bottom: 10px;
  font-size: 22px;
  font-weight: 400;
  font-family: "Fanwood Text", serif;
  color: ${Variables.colorBlackDark};
`;

export const styleButtonNews = {
  backgroundColor: Variables.colorWhite,
  color: Variables.colorGray,
  borderColor: Variables.colorBlack,
  borderStyle: "solid",
  borderWidth: 2,
  marginBottom: 0,
  marginTop: 0,
  width: "50%",
  height: "30px",
};
